module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-17-f09b26d9c2d2d464052b652565fcb6ac.png";